


import * as commonConst from '../common/constants';
import * as projectConst from './constants';
import * as projectApis from '../../services/apis/projects';
import Vue from 'vue';

export default {
    [projectConst.getProjects](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(projectApis.getProjects,{params:params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                data.ListProjectResult.ProjectList = _.orderBy(data.ListProjectResult.ProjectList, 'ProjectId', 'asc');
                ctx.commit(projectConst.getProjects, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },   
    [projectConst.changeProjects](ctx, params) {
        
        return new Promise ((resolve, reject) => {
            params = _.merge(params, projectApis.changeProjects);
            
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    }
    
};

